import { BoldHeader1 } from "src/apps/components/typography/Texts";
import { MEDIA_MOBILE_BREAKPOINT } from "src/apps/config/constants";
import { useDocumentationArea } from "src/apps/hooks/useDocumentationArea";
import styled, { useTheme } from "styled-components";
import { Text } from "src/apps/components/typography/Texts";

import { T } from "src/apps/components/i18n/Translation";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { ActorSelector } from "./components/ActorSelector";
import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { DefaultActorInfo } from "./components/DefaultActorInfo";
import { ActorActionsMenu } from "./components/ActorInvitationAction";
import { ActorChangeTemplateModal } from "./components/ActorChangeTemplateModal";
import { colors } from "@permisso/permisso-components";

const DOCUMENTATION_AREA_SCREEN_HEADER = "documentation_area.screen_header";
const DOCUMENTATION_AREA_SCREEN_DESCRIPTION = "documentation_area.screen_description";
const DOCUMENTATION_AREA_SCREEN_DESCRIPTION_MOBILE =
  "documentation_area.upload_documentation_here.description.mobile";
const DOCUMENTATION_AREA_SCREEN_DESCRIPTION_READONLY_ACTOR =
  "documentation_area.description.readonly_actor";

export const DocumentationAreaScreenHeader = () => {
  const {
    actor,
    availableActors,
    selectedActorId,
    setSelectedActorId,
    representativeIdNumber,
    isReadOnly,
    documentationArea,
  } = useDocumentationArea();
  const { blackColor } = useTheme();
  const { isDesktop, isMobile } = useIsMedia();

  return (
    <HeaderContainer>
      <TextContainer>
        <BoldHeader1 $color={blackColor}>
          <T k={DOCUMENTATION_AREA_SCREEN_HEADER} />
        </BoldHeader1>
        <Text $color={colors.grey700}>
          <T
            k={
              isDesktop
                ? DOCUMENTATION_AREA_SCREEN_DESCRIPTION
                : DOCUMENTATION_AREA_SCREEN_DESCRIPTION_MOBILE
            }
          />
        </Text>
      </TextContainer>
      <ActorSection>
        {availableActors.length > 1 ? (
          <ActorSelector
            availableActors={availableActors}
            selectedActorId={selectedActorId}
            representativeIdNumber={representativeIdNumber?.number ?? null}
            onSelectActor={setSelectedActorId}
            blackColor={blackColor}
            isDesktop={isDesktop}
            isMobile={isMobile}
          />
        ) : (
          <DefaultActorInfo
            identity={actor?.getIdentity() ?? null}
            type={documentationArea?.getType() ?? null}
          />
        )}
        <ActorActionsMenu isMobile={isMobile} />
      </ActorSection>
      <ActorChangeTemplateModal />
      {isReadOnly && !isMobile && (
        <Container>
          <Icon path={ICON_PATHS.INFO} size={ICON_SIZES.s20} color={colors.grey700} />
          <ReadOnlyTextInfo>
            <T k={DOCUMENTATION_AREA_SCREEN_DESCRIPTION_READONLY_ACTOR} />
          </ReadOnlyTextInfo>
        </Container>
      )}
    </HeaderContainer>
  );
};

const TextContainer = styled.div`
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.375rem;
  align-items: center;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media (max-width: ${MEDIA_MOBILE_BREAKPOINT}rem) {
    padding: 2rem 1rem;
    border-bottom: 1px solid ${colors.grey400};
  }
`;

const ReadOnlyTextInfo = styled.div`
  color: ${colors.grey700};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
`;

const ActorSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;
